/**
 * Runtime configuration read from Vite env. This is the ONLY place env vars are
 * read. The data-provider switch here is the seam that lets the app run against
 * the in-browser mock or a real Supabase backend without any component change.
 */
export type DataProviderKind = 'mock' | 'supabase';

interface RuntimeConfig {
  dataProvider: DataProviderKind;
  supabaseUrl: string | null;
  supabaseAnonKey: string | null;
  /** Trusted backend proxy that fronts the Raspberry Pi. Frontend never hits the Pi directly. */
  backendUrl: string | null;
  defaultClubId: string;
  featureFlags: string[];
}

function readProvider(raw: string | undefined): DataProviderKind {
  return raw === 'supabase' ? 'supabase' : 'mock';
}

function nonEmpty(value: string | undefined): string | null {
  return value && value.trim().length > 0 ? value.trim() : null;
}

export const runtimeConfig: RuntimeConfig = {
  dataProvider: readProvider(import.meta.env.VITE_DATA_PROVIDER),
  supabaseUrl: nonEmpty(import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: nonEmpty(import.meta.env.VITE_SUPABASE_ANON_KEY),
  backendUrl: nonEmpty(import.meta.env.VITE_BACKEND_URL),
  defaultClubId: nonEmpty(import.meta.env.VITE_DEFAULT_CLUB_ID) ?? 'high-eight',
  featureFlags: (nonEmpty(import.meta.env.VITE_FEATURE_FLAGS) ?? '')
    .split(',')
    .map((f) => f.trim())
    .filter(Boolean),
};

export const isMock = runtimeConfig.dataProvider === 'mock';
